export default __webpack_public_path__ + "slices/main/assets/public/media/product/platform/platform-feature-behavior@2x.71735a24795c18a038a5d14994a41045.png";